import posthog from 'posthog-js';
import { OBS_CONFIG } from './observability';

let initialized = false;

export function initPostHog() {
  if (initialized || !OBS_CONFIG.posthogKey) return;
  posthog.init(OBS_CONFIG.posthogKey, {
    api_host: OBS_CONFIG.posthogHost,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: {
      dom_event_allowlist: ['click'],
    },
    mask_all_text: false,
    disable_session_recording: !OBS_CONFIG.isProd,
    loaded: (ph) => {
      if (!OBS_CONFIG.isProd) ph.opt_out_capturing();
    },
  });
  initialized = true;
}

export function identifyAnalyticsUser(customerId: string | null) {
  if (!initialized) return;
  if (customerId) {
    posthog.identify(customerId);
  } else {
    posthog.reset();
  }
}

export type EventName =
  | 'qr_scanned'
  | 'venue_qr_scan'
  | 'venue_promo_click'
  | 'order_viewed'
  | 'upsell_shown'
  | 'upsell_clicked'
  | 'upsell_added'
  | 'upsell_purchased'
  | 'upsell_offer_applied'
  | 'auth_started'
  | 'auth_completed'
  | 'challenge_viewed'
  | 'challenge_joined'
  | 'gift_sent'
  | 'gift_redeemed';

export function track(event: EventName, props: Record<string, unknown> = {}) {
  if (!initialized) return;
  posthog.capture(event, {
    ...props,
    release: OBS_CONFIG.release,
  });
}

export function isAnalyticsEnabled(): boolean {
  return initialized;
}

export async function initWebVitals() {
  if (!initialized) return;
  try {
    const { onCLS, onLCP, onINP, onTTFB, onFCP } = await import('web-vitals');
    const report = (metric: { name: string; value: number; rating: string; id: string }) => {
      posthog.capture('web_vital', {
        metric: metric.name,
        value: metric.value,
        rating: metric.rating,
        id: metric.id,
        release: OBS_CONFIG.release,
      });
    };
    onCLS(report);
    onLCP(report);
    onINP(report);
    onTTFB(report);
    onFCP(report);
  } catch {
    /* web-vitals optional */
  }
}

export { posthog };
